import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type {
  FreeMaterialCourse,
  FreeMaterialReview,
  FreeMaterialSettings,
  FreeMaterialStudentEnrollment,
} from "@/types/freeMaterialsTypes"

export function useFreeMaterialData() {
  return useGenericQuery<Array<FreeMaterialCourse>>({
    apiEndpoint: ENDPOINTS.freeMaterials.index(),
    keys: QUERY_KEYS.freeMaterials.index(),
    paginated: true,
  })
}

export function useStudentFreeMaterialEnrollments() {
  return useGenericQuery<Array<FreeMaterialStudentEnrollment>>({
    apiEndpoint: ENDPOINTS.freeMaterials.enrollments(),
    keys: QUERY_KEYS.freeMaterials.enrollments(),
  })
}

export function useFreeMaterialSettings() {
  return useGenericQuery<FreeMaterialSettings>({
    apiEndpoint: ENDPOINTS.freeMaterials.settings(),
    keys: QUERY_KEYS.freeMaterials.settings(),
  })
}

export function useFreeMaterialCourseReviews(courseId?: number) {
  return useGenericQuery<{
    reviews: Array<FreeMaterialReview>
    myReview: FreeMaterialReview
  }>({
    apiEndpoint: ENDPOINTS.freeMaterials.getReviews(courseId || 0),
    keys: QUERY_KEYS.freeMaterials.reviews(),
  })
}
